module.exports = __webpack_public_path__ + "img/age-title.c3b995ce.png";